
import React from 'react';
import { AdminHeader } from '@/components/admin/AdminHeader';
import { AdminSidebar } from '@/components/admin/AdminSidebar';
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import { BottomNavigation } from '@/components/admin/navigation/BottomNavigation';

interface AdminLayoutProps {
  children: React.ReactNode;
}

export function AdminLayout({ children }: AdminLayoutProps) {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <div className="hidden md:block">
          <AdminSidebar />
        </div>
        <SidebarInset>
          <AdminHeader />
          <div className="flex-1 px-4 pb-20 md:px-6 md:pb-6">{children}</div>
          <BottomNavigation />
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
}
